import React from 'react'
import './establishment-card.css'
import { FaStore } from "react-icons/fa";
import Button from '../../../components/basic/button'

const EstablishmentCard = () => {

    return (
        <div className='establishment-card' >

            <div className="icon-content">
                <div className="icon">
                    <FaStore />
                </div>
            </div>

            <div className="content">
                <span className='app-title'>Salão do Seu Manoel</span>
                <span className='app-text description'>Cuidado, qualidade e bem estar para você</span>
                <span className='app-text description2'>Aqui você encontra os melhores serviços em um ambiente acolhedor, profissional e feito para realçar a sua melhor versão.</span>

                <Button Style='primary-color' Label='Agende agora' Action='/services' Icon='calendar' Direction='Next' />
            </div>

        </div>
    )
}

export default EstablishmentCard